import type { ReactNode } from 'react'

import { AIGovernanceIcon } from './ai-governance-icon'

// A set filter's getIcon: the dropdown icon for the listed values that are AI governance.
export const aiGovernanceFilterIcon = (aiValues: ReadonlySet<string>) =>
  function getIcon(value: string): ReactNode {
    return aiValues.has(value) ? (
      <AIGovernanceIcon className='text-main-foreground-secondary' />
    ) : null
  }
